import CheckboxAndRadioContainer from "../../../../components/formsAndTable/forms/formControls/checkboxAndRadio";

const CheckBoxAndRadio = () => {
  return <CheckboxAndRadioContainer />;
};

export default CheckBoxAndRadio;
